{
  "toolchain": {
    "webLlmModelVersion": "v0_2_87/base",
    "tvm": "e345029cedf0be76a087fcad9c89a97bed4f7204",
    "mlcLlm": "44fd06d04f22c87820e205b0f2b2e5e6a1f6ca85",
    "emsdkImage": "emscripten/emsdk:4.0.23@sha256:86537645c51e44899812d29820ee3b64b96c321ebb2aba4416a04ceeb1bcde62",
    "prefillChunkSize": 1024,
    "license": "apache-2.0",
    "notices": [
      "tvm-notice.txt",
      "mlc-llm-notice.txt"
    ]
  },
  "licenses": {
    "apache-2.0": {
      "name": "Apache License 2.0",
      "file": "apache-2.0.txt"
    },
    "llama-3.1": {
      "name": "Llama 3.1 Community License",
      "file": "llama-3.1-license.txt",
      "notice": "Llama 3.1 is licensed under the Llama 3.1 Community License, Copyright © Meta Platforms, Inc. All Rights Reserved."
    },
    "llama-3.2": {
      "name": "Llama 3.2 Community License",
      "file": "llama-3.2-license.txt",
      "notice": "Llama 3.2 is licensed under the Llama 3.2 Community License, Copyright © Meta Platforms, Inc. All Rights Reserved."
    },
    "mit-phi-4-mini": {
      "name": "MIT License",
      "file": "phi-4-mini-license.txt",
      "extraFiles": {
        "NOTICE.md": "phi-4-mini-notice.md"
      }
    }
  },
  "vendored": {
    "apache-2.0.txt": {
      "source": "https://www.apache.org/licenses/LICENSE-2.0.txt",
      "integrity": "sha256-z8d0m5b2O9McPEK1xHG/dWgUBT6EfBDz6wA0F7xSPTA="
    },
    "llama-3.1-license.txt": {
      "source": "https://raw.githubusercontent.com/meta-llama/llama-models/0e0b8c519242d5833d8c11bffc1232b77ad7f301/models/llama3_1/LICENSE",
      "integrity": "sha256-vy6sYLgeXF93n8O0hJ07+s/WP5fz62i0TpxoaMWAFxI="
    },
    "llama-3.2-license.txt": {
      "source": "https://raw.githubusercontent.com/meta-llama/llama-models/0e0b8c519242d5833d8c11bffc1232b77ad7f301/models/llama3_2/LICENSE",
      "integrity": "sha256-jMFVNaijS0GIj2RLM5oanrQor3k6T14k31ij5bFIfXQ="
    },
    "phi-4-mini-license.txt": {
      "source": "https://huggingface.co/microsoft/Phi-4-mini-instruct/resolve/cfbefacb99257ffa30c83adab238a50856ac3083/LICENSE",
      "integrity": "sha256-+oI15bSPrKNOPKmM9PaU7wi9IW0otYBxofhbHVDLgU0="
    },
    "phi-4-mini-notice.md": {
      "source": "https://huggingface.co/microsoft/Phi-4-mini-instruct/resolve/cfbefacb99257ffa30c83adab238a50856ac3083/NOTICE.md",
      "integrity": "sha256-ozhsxxJex17TTU8KNAxHeCmCCV4lHTIuAdjsqyLYe6Q="
    },
    "tvm-notice.txt": {
      "source": "https://raw.githubusercontent.com/apache/tvm/e345029cedf0be76a087fcad9c89a97bed4f7204/NOTICE",
      "integrity": "sha256-lnzS+5dxLEMnHiscT2NsTYgjiYhp8PdvZb+KMjJYTw8="
    },
    "mlc-llm-notice.txt": {
      "source": "https://raw.githubusercontent.com/mlc-ai/mlc-llm/44fd06d04f22c87820e205b0f2b2e5e6a1f6ca85/NOTICE",
      "integrity": "sha256-On37N7uWzm9aHMDW1MjaO4o15uxGkmR7oKN/YVXH5pQ="
    }
  },
  "modificationNote": "Modifications: the weights were converted to the MLC format by MLC (mlc-ai), quantized to 4 bits for the q4 builds; the model library was compiled by VoiceDojo with the MLC toolchain (MLC LLM, Apache TVM).",
  "webLlm": [
    {
      "displayName": "Llama 3.2 1B Instruct",
      "tier": "tiny",
      "recommended": true,
      "upstream": "https://huggingface.co/meta-llama/Llama-3.2-1B-Instruct",
      "license": "llama-3.2",
      "variants": [
        {
          "id": "Llama-3.2-1B-Instruct-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Llama-3.2-1B-Instruct-q4f16_1-MLC/resolve/2a37b0a5ecb622d51ddc2fac74de0b95872affd7/",
          "integrity": {
            "config": "sha256-DsUTtUtBmtRxAGQwaGvc/6rnECtB97Akb7/N4lF6zH8=",
            "model_lib": "sha256-0K7he8yeeaEZVR3sHKhx8nVvg+gEIvkKQF7Iy/0qhnM=",
            "tokenizer": {
              "tokenizer.json": "sha256-eePlImNfMXEwCRO7QhRkqH3mIiGCoFcLmyzLoqlksrQ="
            }
          }
        },
        {
          "id": "Llama-3.2-1B-Instruct-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Llama-3.2-1B-Instruct-q4f32_1-MLC/resolve/a949835e0f9a65335bd834db02a44cf8fae34020/",
          "integrity": {
            "config": "sha256-BGVh5aSNDJJrH8pWNyDFNIe1kUn+lYoYmo7mwI4O7zQ=",
            "model_lib": "sha256-gfJ3FH7zgdYvEp+iQSLAvA9UbVTfdhLBbKSLwEZIgH0=",
            "tokenizer": {
              "tokenizer.json": "sha256-eePlImNfMXEwCRO7QhRkqH3mIiGCoFcLmyzLoqlksrQ="
            }
          }
        }
      ]
    },
    {
      "displayName": "Qwen 2.5 0.5B Instruct",
      "tier": "tiny",
      "upstream": "https://huggingface.co/Qwen/Qwen2.5-0.5B-Instruct",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "Qwen2.5-0.5B-Instruct-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen2.5-0.5B-Instruct-q4f16_1-MLC/resolve/32ff081fe7e4dfe4ffb167b94c66fdf11e02b8ad/",
          "integrity": {
            "config": "sha256-VDnAO99O58/g+Kl6ZYgBiwFE3BKAxxu66ihTzbq4dLk=",
            "model_lib": "sha256-sCEx+OmWI+rNDKmv5gxaxfEVV+5NX+bAyueqnfldLC8=",
            "tokenizer": {
              "tokenizer.json": "sha256-wDghF+oynN8JcEETL21zWSS2l5JNb2/DlFcT6WzodTk="
            }
          }
        },
        {
          "id": "Qwen2.5-0.5B-Instruct-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen2.5-0.5B-Instruct-q4f32_1-MLC/resolve/8e6ec5f417c7d0e1414703ef619b8a24686e3ab0/",
          "integrity": {
            "config": "sha256-asELWAWyLILxhn2b5hUw0DdV6HQcK3M18SD/ocFa6PE=",
            "model_lib": "sha256-qwGPcf5b6/JV0G5X17WPJx1ZypyYP9k4DKJ9/Y+hZKk=",
            "tokenizer": {
              "tokenizer.json": "sha256-wDghF+oynN8JcEETL21zWSS2l5JNb2/DlFcT6WzodTk="
            }
          }
        }
      ]
    },
    {
      "displayName": "SmolLM2 360M Instruct",
      "tier": "tiny",
      "upstream": "https://huggingface.co/HuggingFaceTB/SmolLM2-360M-Instruct",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "SmolLM2-360M-Instruct-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/SmolLM2-360M-Instruct-q4f16_1-MLC/resolve/3a622fd89e0216e8bb10c410c007c786baa8a033/",
          "integrity": {
            "config": "sha256-tzKWmdb9v1pPaKDEKxQlD0vqssq7+hIPrmySTn3Njyw=",
            "model_lib": "sha256-Vrnork5NGcv9HDt5Sri0ba1dhdBhx3V6CdjvEBa1VIo=",
            "tokenizer": {
              "tokenizer.json": "sha256-nKms3bZSWhlOyKx6h/JPu6cjKpoV/6GvDBIk/NiI5Hw="
            }
          }
        },
        {
          "id": "SmolLM2-360M-Instruct-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/SmolLM2-360M-Instruct-q4f32_1-MLC/resolve/1e6b2ca3684e2bc8a6d39eb36e8d6cd51eb12bda/",
          "integrity": {
            "config": "sha256-DBL1sGAjna7dEwTK//Gcws4NPoGTWchVYTlNFgSSROY=",
            "model_lib": "sha256-dIQ09Q61dhuueRmxfBw9DF7rPChYXbRh68ajIwJYHPY=",
            "tokenizer": {
              "tokenizer.json": "sha256-nKms3bZSWhlOyKx6h/JPu6cjKpoV/6GvDBIk/NiI5Hw="
            }
          }
        }
      ]
    },
    {
      "displayName": "SmolLM2 135M Instruct",
      "tier": "tiny",
      "perfNote": "fastest",
      "upstream": "https://huggingface.co/HuggingFaceTB/SmolLM2-135M-Instruct",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "SmolLM2-135M-Instruct-q0f16-MLC",
          "model": "https://huggingface.co/mlc-ai/SmolLM2-135M-Instruct-q0f16-MLC/resolve/06fc409f2212adff29d93cbc742c1d6957302df5/",
          "integrity": {
            "config": "sha256-hPqM2kfEQ1idBccpUzmwxYwV2WTn8t9ThzNmGHeJu1k=",
            "model_lib": "sha256-XIIiTBknskVduO6+Wy2s6KDsj+rU1CQW6NP1HYT9BfQ=",
            "tokenizer": {
              "tokenizer.json": "sha256-nKms3bZSWhlOyKx6h/JPu6cjKpoV/6GvDBIk/NiI5Hw="
            }
          }
        },
        {
          "id": "SmolLM2-135M-Instruct-q0f32-MLC",
          "model": "https://huggingface.co/mlc-ai/SmolLM2-135M-Instruct-q0f32-MLC/resolve/ba1ecf858a4dfc6ac3e668c388a7088bdfb3c091/",
          "integrity": {
            "config": "sha256-Dek77fxR2JeXHyCPFyPg1LEsSATAjwJNS+l2EA32KAY=",
            "model_lib": "sha256-hcIXl9gxtbWuJvl3fZE00a6aBpLOlDwFZvrZ/u6XPp8=",
            "tokenizer": {
              "tokenizer.json": "sha256-nKms3bZSWhlOyKx6h/JPu6cjKpoV/6GvDBIk/NiI5Hw="
            }
          }
        }
      ]
    },
    {
      "displayName": "Llama 3.2 3B Instruct",
      "tier": "small",
      "recommended": true,
      "upstream": "https://huggingface.co/meta-llama/Llama-3.2-3B-Instruct",
      "license": "llama-3.2",
      "variants": [
        {
          "id": "Llama-3.2-3B-Instruct-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Llama-3.2-3B-Instruct-q4f16_1-MLC/resolve/1e80abf71e3d17cd564e2d2b63caa15cb226018e/",
          "integrity": {
            "config": "sha256-ELIxjYcTIMpmyGt6RMtETOp2d+B4obFH1OBkaViofb4=",
            "model_lib": "sha256-clFHO/FSjpQhygo0yXM8I+Z/na5DF9CtgyLm9LkTpBI=",
            "tokenizer": {
              "tokenizer.json": "sha256-eePlImNfMXEwCRO7QhRkqH3mIiGCoFcLmyzLoqlksrQ="
            }
          }
        },
        {
          "id": "Llama-3.2-3B-Instruct-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Llama-3.2-3B-Instruct-q4f32_1-MLC/resolve/6083cfdaaf08d2dd4872d7f5b87fb0242aa7d75c/",
          "integrity": {
            "config": "sha256-wnLypNTZn34QjdyLsgfOCergrr/HfStyrWO4FuWwfPc=",
            "model_lib": "sha256-u06VB76rb7tIdM+FbXeVQPm5qpb+eBE9z1++AIzzeHQ=",
            "tokenizer": {
              "tokenizer.json": "sha256-eePlImNfMXEwCRO7QhRkqH3mIiGCoFcLmyzLoqlksrQ="
            }
          }
        }
      ]
    },
    {
      "displayName": "Qwen 3.5 2B",
      "tier": "small",
      "upstream": "https://huggingface.co/Qwen/Qwen3.5-2B",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "Qwen3.5-2B-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen3.5-2B-q4f16_1-MLC/resolve/dd74e9c8a20c4546df85c844103bff87b6dcacad/",
          "integrity": {
            "config": "sha256-Q1d7bemkxizw/pxe5XvFLrsvxIfGSiG/eNYkMRhrSwE=",
            "model_lib": "sha256-8BAn41pi+Px3wYq9/O5KJumFtCEq7rnGFw3wt8UuAQE=",
            "tokenizer": {
              "tokenizer.json": "sha256-X55NSQGpK5l+RjwfRgVQiLbMpcphplItG59kxLuBy0I="
            }
          }
        },
        {
          "id": "Qwen3.5-2B-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen3.5-2B-q4f32_1-MLC/resolve/d835e5c41aa56174d915e8a3940cde599d3f5a30/",
          "integrity": {
            "config": "sha256-V7HcLkj2pHewv8gi6vNjNqQFvo/3t2BYySIoWpK3EQ8=",
            "model_lib": "sha256-f6KDOPedV1ZtC0Lcjkks21lsHqxVo3GaBJshaHgVQMU=",
            "tokenizer": {
              "tokenizer.json": "sha256-X55NSQGpK5l+RjwfRgVQiLbMpcphplItG59kxLuBy0I="
            }
          }
        }
      ]
    },
    {
      "displayName": "SmolLM2 1.7B Instruct",
      "tier": "small",
      "upstream": "https://huggingface.co/HuggingFaceTB/SmolLM2-1.7B-Instruct",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "SmolLM2-1.7B-Instruct-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/SmolLM2-1.7B-Instruct-q4f16_1-MLC/resolve/84f57f8580a9d8d623266b600ad4273bb9fd84c1/",
          "integrity": {
            "config": "sha256-skagzcvcZdVGsyDJYFVfUFxPBhr5Gd+ax9eTiV89SOU=",
            "model_lib": "sha256-ExR/unECP90GEWenyW1L3UXftin19v/46VXAVTOCAYs=",
            "tokenizer": {
              "tokenizer.json": "sha256-nKms3bZSWhlOyKx6h/JPu6cjKpoV/6GvDBIk/NiI5Hw="
            }
          }
        },
        {
          "id": "SmolLM2-1.7B-Instruct-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/SmolLM2-1.7B-Instruct-q4f32_1-MLC/resolve/0b81fd80381d396f37216e4c74e958024c589e24/",
          "integrity": {
            "config": "sha256-b2hm5Q5gEjy88x/b1prZ4ICs8AKOE1RAjuSQrubMH3k=",
            "model_lib": "sha256-67Stys/S7K8efBRKCu1NOVSLANG73hQ3HzFqOIgK7F8=",
            "tokenizer": {
              "tokenizer.json": "sha256-nKms3bZSWhlOyKx6h/JPu6cjKpoV/6GvDBIk/NiI5Hw="
            }
          }
        }
      ]
    },
    {
      "displayName": "OLMo 2 0425 1B Instruct",
      "tier": "small",
      "upstream": "https://huggingface.co/allenai/OLMo-2-0425-1B-Instruct",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "OLMo-2-0425-1B-Instruct-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/OLMo-2-0425-1B-Instruct-q4f16_1-MLC/resolve/a3fef630301a7e9a4dcbbdd3a76b0d36b20dc85e/",
          "integrity": {
            "config": "sha256-4MjuKwbZnDBfCTmIIb4YfiUL7U8qq1uJSqiLsjWClJQ=",
            "model_lib": "sha256-OU+3hp9iEaVt6IGVYo3IuZGJweK6ai9zb/fj7c7eavk=",
            "tokenizer": {
              "tokenizer.json": "sha256-c/1SVGJPOaiOP6rGqOETAPw8c17TeIDU9PCNuJjq7Mo="
            }
          }
        },
        {
          "id": "OLMo-2-0425-1B-Instruct-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/OLMo-2-0425-1B-Instruct-q4f32_1-MLC/resolve/cbcbcfa8e266f1b19adc2c4d50a19323eb58886c/",
          "integrity": {
            "config": "sha256-Nk5UkE+VoVVVODlN+BbQtmgAWsNL0NzFAzyApEqtOzs=",
            "model_lib": "sha256-WHiTZaCWkcTGQH4xEYITUGYns8dp//SbOJ5WhzSlOIY=",
            "tokenizer": {
              "tokenizer.json": "sha256-c/1SVGJPOaiOP6rGqOETAPw8c17TeIDU9PCNuJjq7Mo="
            }
          }
        }
      ]
    },
    {
      "displayName": "Qwen 3.5 0.8B",
      "tier": "small",
      "upstream": "https://huggingface.co/Qwen/Qwen3.5-0.8B",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "Qwen3.5-0.8B-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen3.5-0.8B-q4f16_1-MLC/resolve/0ec138972555613c1d7812a821778ad0398c8790/",
          "integrity": {
            "config": "sha256-Hqk8K4s5ajdUUW0MS29LaIHCkwyizGyyzwDlEea+hqk=",
            "model_lib": "sha256-+d1GEx1Diq/BH0SZteqAd4lY5c/qk4gEmk0UB8OoBr8=",
            "tokenizer": {
              "tokenizer.json": "sha256-X55NSQGpK5l+RjwfRgVQiLbMpcphplItG59kxLuBy0I="
            }
          }
        },
        {
          "id": "Qwen3.5-0.8B-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen3.5-0.8B-q4f32_1-MLC/resolve/4ed017713f04c91ffe55a9dca8c7ac853c41314d/",
          "integrity": {
            "config": "sha256-9d/M+tq7mYqa59Np1R5WEb3a5fTgGiv3yyRWc61YlHA=",
            "model_lib": "sha256-9Va9mj9CxZ1o+z7Yj4PEwYLoP62sXBQcBwJhIc5ly94=",
            "tokenizer": {
              "tokenizer.json": "sha256-X55NSQGpK5l+RjwfRgVQiLbMpcphplItG59kxLuBy0I="
            }
          }
        }
      ]
    },
    {
      "displayName": "Phi 4 Mini Instruct",
      "tier": "medium",
      "recommended": true,
      "upstream": "https://huggingface.co/microsoft/Phi-4-mini-instruct",
      "license": "mit-phi-4-mini",
      "variants": [
        {
          "id": "Phi-4-mini-instruct-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Phi-4-mini-instruct-q4f16_1-MLC/resolve/c2ecf2bf3a81d201ccdbfb9019d67fb8f0dede52/",
          "integrity": {
            "config": "sha256-+ZdkUE7aR17cQl1sh2kAXu3TXHribkAsee33IsmiOfw=",
            "model_lib": "sha256-A3J/orGJYK4N8Zm6m+GBMsghaGVkWg1r6QSK+hT95HE=",
            "tokenizer": {
              "tokenizer.json": "sha256-OCzCNbVscllF4UnMJfGR2mZ8g2ZV79CFewBDIOkOkeo="
            }
          }
        },
        {
          "id": "Phi-4-mini-instruct-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Phi-4-mini-instruct-q4f32_1-MLC/resolve/0477d44927a18ff49282017e0f4c3033744e80ca/",
          "integrity": {
            "config": "sha256-CzLYVxOfSgBMf4sJcRYyCX4NlWCz7JgTFc/VeR1Y7wU=",
            "model_lib": "sha256-htMMJpDxEKGzqqwYIeHIOr9Wr5qiMqF0HrVBdIIcptY=",
            "tokenizer": {
              "tokenizer.json": "sha256-OCzCNbVscllF4UnMJfGR2mZ8g2ZV79CFewBDIOkOkeo="
            }
          }
        }
      ]
    },
    {
      "displayName": "Qwen 3.5 4B",
      "tier": "medium",
      "upstream": "https://huggingface.co/Qwen/Qwen3.5-4B",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "Qwen3.5-4B-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen3.5-4B-q4f16_1-MLC/resolve/44b42469f9e192814bfd90440e3b377d89ba7a13/",
          "integrity": {
            "config": "sha256-uU1Tv95bSW2NliOb9GhOJLU5QgnlrvkSeGbvpFQ5VlE=",
            "model_lib": "sha256-S9rkVp91Nbzc5jfoe8IpQ2VgAm+pTwjffnvsStUaeB8=",
            "tokenizer": {
              "tokenizer.json": "sha256-X55NSQGpK5l+RjwfRgVQiLbMpcphplItG59kxLuBy0I="
            }
          }
        },
        {
          "id": "Qwen3.5-4B-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen3.5-4B-q4f32_1-MLC/resolve/ce39652c7b493d59331e40ef9c7a87de5a47abe3/",
          "integrity": {
            "config": "sha256-DQc+M5Q6+yHmhIZfYscw4ByJT+m90isggi5L2b4oTi4=",
            "model_lib": "sha256-E6wD6Zd6DDe+wBHPqrO1V6rhIh9c2jPrO9uipzWUGqc=",
            "tokenizer": {
              "tokenizer.json": "sha256-X55NSQGpK5l+RjwfRgVQiLbMpcphplItG59kxLuBy0I="
            }
          }
        }
      ]
    },
    {
      "displayName": "Ministral 3 3B Instruct",
      "tier": "medium",
      "upstream": "https://huggingface.co/mistralai/Ministral-3-3B-Instruct-2512-BF16",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "Ministral-3-3B-Instruct-2512-BF16-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Ministral-3-3B-Instruct-2512-BF16-q4f16_1-MLC/resolve/eebad8da4ac64947d8dc9507007fc0279bf52454/",
          "integrity": {
            "config": "sha256-183aI4HvxSRvGsiInDLfSmjm/EVn3w60519fmfwCMaQ=",
            "model_lib": "sha256-X/jwN1qYbsdjN81XUT3730lVgau+KJCiyxVCC7VN3ug=",
            "tokenizer": {
              "tokenizer.json": "sha256-V3V1YiMksuCZ4mSL4mveteWBX/5m1wBOnj3b9CHba/E="
            }
          }
        },
        {
          "id": "Ministral-3-3B-Instruct-2512-BF16-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Ministral-3-3B-Instruct-2512-BF16-q4f32_1-MLC/resolve/37ac6cfe41d24aff036c6b3fe37e1469272c4cb4/",
          "integrity": {
            "config": "sha256-7hhFnnOB2sD6N7yPnjclUNpc4NQ100OQM67pDKva8T4=",
            "model_lib": "sha256-8VHRPcE7Sml/uneHLRB1JjKxTr1HLHPI6ZxAAHpPfOs=",
            "tokenizer": {
              "tokenizer.json": "sha256-V3V1YiMksuCZ4mSL4mveteWBX/5m1wBOnj3b9CHba/E="
            }
          }
        }
      ]
    },
    {
      "displayName": "Gemma 4 E2B Instruct",
      "tier": "medium",
      "upstream": "https://huggingface.co/google/gemma-4-E2B-it",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "gemma-4-E2B-it-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/gemma-4-E2B-it-q4f16_1-MLC/resolve/633df598b7a473759367855273c63912c9e2bc9a/",
          "prefillChunkSize": 512,
          "integrity": {
            "config": "sha256-ffrJa4/Mq3SfiI/Oz5VA46E45sfnLfJiPfKAplplgCU=",
            "model_lib": "sha256-c8doOXFPGbqRfPAKv2k2kj2GppVesiIUcdSPf6jOfT4=",
            "tokenizer": {
              "tokenizer.json": "sha256-zI06DONkZszBJ4v5h99fcdsXGbnKa0EYJk9Fy2J7/g8="
            }
          }
        },
        {
          "id": "gemma-4-E2B-it-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/gemma-4-E2B-it-q4f32_1-MLC/resolve/db5bcb53aa58acb27777ba02a891ff5c95d26ccf/",
          "prefillChunkSize": 512,
          "integrity": {
            "config": "sha256-SQpyphAXUAp9KnpAi+YYUTx5GqUgrP+a+lQyCwMlVsE=",
            "model_lib": "sha256-ILfs6E8r5dfWFOcM2fqXOGyvHR3eqlobbxklkPZCqGc=",
            "tokenizer": {
              "tokenizer.json": "sha256-zI06DONkZszBJ4v5h99fcdsXGbnKa0EYJk9Fy2J7/g8="
            }
          }
        }
      ]
    },
    {
      "displayName": "Llama 3.1 8B Instruct",
      "tier": "large",
      "recommended": true,
      "upstream": "https://huggingface.co/meta-llama/Llama-3.1-8B-Instruct",
      "license": "llama-3.1",
      "variants": [
        {
          "id": "Llama-3.1-8B-Instruct-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Llama-3.1-8B-Instruct-q4f16_1-MLC/resolve/ac109a0e5f6dc3c2f4fbe02c20192f9f4665900d/",
          "integrity": {
            "config": "sha256-B06ZELdcsxiUJ0uaAwZvZY98FT5+NzdwxgIt6A+d5y0=",
            "model_lib": "sha256-rnJeeCdK/Jmh+8sISNAsSQ/Cqw20wzaQdVOQA0ahjRg=",
            "tokenizer": {
              "tokenizer.json": "sha256-u8GQTTUWnFQt/74fdYmlmU7HQm2eW2CdB7q4dvMul6s="
            }
          }
        },
        {
          "id": "Llama-3.1-8B-Instruct-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Llama-3.1-8B-Instruct-q4f32_1-MLC/resolve/3ac29bcbc3cae42adce3a2928726f51fecbdbd08/",
          "integrity": {
            "config": "sha256-2v9jYJm60S7XkxGejrGsUnsZc9BESQ0irg9OEWRdEB4=",
            "model_lib": "sha256-zT9ijrTbJNkVnxEu4ODF4Gy4zatkvezMWLsEOJvSdaQ=",
            "tokenizer": {
              "tokenizer.json": "sha256-u8GQTTUWnFQt/74fdYmlmU7HQm2eW2CdB7q4dvMul6s="
            }
          }
        }
      ]
    },
    {
      "displayName": "Qwen 3.5 9B",
      "tier": "large",
      "upstream": "https://huggingface.co/Qwen/Qwen3.5-9B",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "Qwen3.5-9B-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen3.5-9B-q4f16_1-MLC/resolve/c7c5d3f5a81e37b8facbb72970940a1b131314a8/",
          "integrity": {
            "config": "sha256-ermWxbWrIF7YJto8OUo3MRceMa4nfljW3DVbQn//+yY=",
            "model_lib": "sha256-G9ITdX1jrcHt1ZuYxG2UeAbwppljzCKwiQP3ZTKFZYY=",
            "tokenizer": {
              "tokenizer.json": "sha256-X55NSQGpK5l+RjwfRgVQiLbMpcphplItG59kxLuBy0I="
            }
          }
        },
        {
          "id": "Qwen3.5-9B-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Qwen3.5-9B-q4f32_1-MLC/resolve/f8f042bfb68cb88573af4c8e0ef9b1a26bef4ad0/",
          "integrity": {
            "config": "sha256-kc4fqMy43twT40eViFu5LNQ5pxJnN3kS6DJFOYMM12E=",
            "model_lib": "sha256-CahO9D7Foy+o8aD04AdBgzzkBkDwVgPBKkdzzJ47PKI=",
            "tokenizer": {
              "tokenizer.json": "sha256-X55NSQGpK5l+RjwfRgVQiLbMpcphplItG59kxLuBy0I="
            }
          }
        }
      ]
    },
    {
      "displayName": "Mistral 7B Instruct v0.3",
      "tier": "large",
      "upstream": "https://huggingface.co/mistralai/Mistral-7B-Instruct-v0.3",
      "license": "apache-2.0",
      "variants": [
        {
          "id": "Mistral-7B-Instruct-v0.3-q4f16_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Mistral-7B-Instruct-v0.3-q4f16_1-MLC/resolve/e06f3992dc08bd7196602031577a550cbfdefc54/",
          "integrity": {
            "config": "sha256-veJWtlXlWHWXkRlK81eAY5wHumdFl8oOmU1AyH9+/4M=",
            "model_lib": "sha256-2scp64SPjhFD1o7MYqHfE+cooKvs6Q6vjU+E1kEs0ds=",
            "tokenizer": {
              "tokenizer.json": "sha256-5VOvb/99etdugwYIshjFwLCCKZjVoalgmadM08HLGkk="
            }
          }
        },
        {
          "id": "Mistral-7B-Instruct-v0.3-q4f32_1-MLC",
          "model": "https://huggingface.co/mlc-ai/Mistral-7B-Instruct-v0.3-q4f32_1-MLC/resolve/b8b76e2bd2fe9983c80bd87e475bd2d9e07c6dba/",
          "integrity": {
            "config": "sha256-nZdlp6blCceA1qPIsmQujLwhmhsXOYMfAR9bH5QC0ss=",
            "model_lib": "sha256-zPwKySaxOVCAQlz+t4eh6YbcY/0oXJDojCWezd68QoI=",
            "tokenizer": {
              "tokenizer.json": "sha256-5VOvb/99etdugwYIshjFwLCCKZjVoalgmadM08HLGkk="
            }
          }
        }
      ]
    }
  ],
  "mediapipe": {
    "wasmBase": "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/wasm/",
    "wasm": {
      "vision_wasm_internal.js": "sha256-5/2YWOjo8iHZuW7dwR+OB38mPgt7vXnTy+iCsTQnT4w=",
      "vision_wasm_internal.wasm": "sha256-alxkWEwqthx2O24gSvvbx84cr39SFhhzIryo35T2Rrw=",
      "vision_wasm_nosimd_internal.js": "sha256-Q40f6P9/TZRgJbwhHCkVQ8A32KN4XtTu5g8fUhsjYpY=",
      "vision_wasm_nosimd_internal.wasm": "sha256-ijCS00x50/V+a6hZIQXoqQ9rB8J4kf/s0UzKQov9PjE="
    },
    "segmenter": {
      "source": "https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/1/selfie_segmenter.tflite",
      "integrity": "sha256-GRrJUprlBu4L7vprLJRaFy2rnQfR6AKikKTkA4ImZYs="
    },
    "license": "apache-2.0"
  }
}
